var map = {
	"./fallback-landscape.png": 198,
	"./fallback-portrait.png": 199,
	"./svg-sprite/icon-arrow.svg": 200,
	"./svg-sprite/icon-blurb.svg": 201,
	"./svg-sprite/icon-chevron.svg": 202,
	"./svg-sprite/icon-close.svg": 203,
	"./svg-sprite/icon-gear.svg": 204,
	"./svg-sprite/icon-info.svg": 205,
	"./svg-sprite/icon-mail.svg": 206,
	"./svg-sprite/icon-minus.svg": 207,
	"./svg-sprite/icon-phone.svg": 208,
	"./svg-sprite/icon-plus.svg": 209,
	"./svg-sprite/icon-search.svg": 210,
	"./svg-sprite/icon-star.svg": 211,
	"./svg-sprite/icon-ticket.svg": 212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 197;